import React from 'react';
import { Box, Modal } from '@mui/material';
import YearlyVatReport from './YearlyVatReport';
import './YearlyVatReport.css';

/** Modal shell around <YearlyVatReport />, for callers that open the report from a button. */
const YearlyVatReportModal = ({ open, onClose, ...reportProps }) => (
    <Modal open={!!open} onClose={onClose} aria-labelledby="yearly-vat-report-modal">
        <Box className="yvr-modal__box">
            <YearlyVatReport {...reportProps} onClose={onClose} />
        </Box>
    </Modal>
);

export default YearlyVatReportModal;
